import HomeView from './../HomeView.vue'
import RequestView from './../layout/ItenRequestView.vue'

function randValue () {
  const rand = Math.random()
  const encode = base64Encode(new TextEncoder().encode(rand))
  return encode
}

function base64Encode (bytes) {
  const binString = String.fromCodePoint(...bytes)
  return btoa(binString)
}

export const homeRoute = [
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    props: (route) => ({ random: route.params.random || randValue() }),
    meta: {
      key: 'view_das'
    }
  }
  // {
  //   path: '/new-request',
  //   name: 'new-request',
  //   component: RequestView,
  //   meta: {
  //     key: 'view_epi'
  //   }
  // }
]
